/**
 *
 */
export const  gUtilityTime = {
  /* 时间戳转时间*/
    timestampToTime: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() + ' ';
      var h = date.getHours() + ':';
      var m = date.getMinutes() + ':';
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    //获取当天时间的0点（type=1）和23.59
    SameDay:function(type){
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var begin=year+"-"+month+"-"+day+" "+"00:00";
      var end=year+"-"+month+"-"+day+" "+"23:59";
      let str1=year+"/"+month+"/"+day+" "+"00:00:00";
      let str2=year+"/"+month+"/"+day+" "+"23:59:59";
      if(type==1){
        return new Date(str1).getTime()/1000;
      }else{
        return new Date(str2).getTime()/1000;
      }
    },
    //获取昨天时间的0点（type=1）和23.59
    YesterDay:function(data,type){
      var now = new Date(data);
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var begin=year+"-"+month+"-"+day+" "+"00:00";
      var end=year+"-"+month+"-"+day+" "+"23:59";
      let str1=year+"/"+month+"/"+day+" "+"00:00:00";
      let str2=year+"/"+month+"/"+day+" "+"23:59:59";
      if(type==1){
        return new Date(str1).getTime()/1000;
      }else{
        return new Date(str2).getTime()/1000;
      }
    },
    //获取当天时间的0点（type=1）和23.59
    YesterDayday:function(data,type){
      var now = new Date(data);
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var begin=year+"-"+month+"-"+day+" "+"00:00";
      var end=year+"-"+month+"-"+day+" "+"23:59";
      let str1=year+"/"+month+"/"+day+" "+"00:00:00";
      let str2=year+"/"+month+"/"+day+" "+"23:59:59";
      if(type==1){
        return (new Date(str1).getTime()/1000)+86400;
      }else{
        return (new Date(str2).getTime()/1000)+86400;
      }
    },
    /* 获取时间戳中的年（type=1）月（type=2）日（type=3）时（type=4）分（type=5） */
      YearMonthDate: function(timestamp,type) {
        var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() + ' ';

        var h = (date.getHours()  < 10 ? '0' + (date.getHours()) : date.getHours() ) + ':';
        var m = (date.getMinutes()  < 10 ? '0' + (date.getMinutes() ) : date.getMinutes());
        var s = date.getSeconds();
        if(type==1){
          return Y
        }else if(type==2){
          return M
        }else if(type==3){
          return D
        }else if(type==4){
          return h
        }else if(type==5){
          return m
        }
      },
      DaySafter7: function() {
         var today=new Date();
         var dateArr=['全部']
         for(var i=0;i<7;i++){
             var newDate=new Date(today.getTime()+i*1000*60*60*24)
             var year=newDate.getFullYear()
             var month=(parseInt(newDate.getMonth())+1)>9?(parseInt(newDate.getMonth())+1):"0"+(parseInt(newDate.getMonth())+1)
             var day=(newDate.getDate())>9?newDate.getDate():"0"+newDate.getDate()
             var fullDate=`${year}-${month}-${day}`
             dateArr.push(fullDate)
         }
         return dateArr
      },
      SameDay:function(itme,type){
        var begin="";
        if(type==1){
          begin=itme+" "+"00:00:00";
        }else{
          begin=itme+" "+"23:59:59";
        }
        return begin
      },
      startTime:function(time) {
          const nowTimeDate = new Date(time)
          return nowTimeDate.setHours(0, 0, 0, 0)
      },
      endTime:function(time) {
          const nowTimeDate = new Date(time)
          return nowTimeDate.setHours(23, 59, 59, 999)
      }
};



// WEBPACK FOOTER //
// ./src/assets/js/utility/UtiltiyTime.js